module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedia"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("For his labor being the unquestionable")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("property of the laborer,")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("no man but he can have a right")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("to what that is once joined to,")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("at least where there is enough, and as good,")]), _vm._v(" "), _c('p', {
    staticClass: "dedia"
  }, [_vm._v("left in common for others.")]), _vm._v(" "), _c('p', {
    staticClass: "dedia-r"
  }, [_c('em', [_vm._v("—John Locke (1690)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e1b3829","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication1.vue
// module id = 72
// module chunks = 0